<template>
  <div>
    <h3 class="tw-font-bold tw-text-lg tw-mt-16">Comparecimento</h3>
    <p v-if="loading">
      <img v-bind:src="loadingImage" class="tw-mx-auto tw-mt-8" >
    </p>
    <p v-if="error && !loading" class="text-center tw- tw-mt-16 tw-text-lg">
      Não foi possível carregar o gráfico. Tente novamente.
    </p>

    <stacked-bar-chart style="height: 500px" class="tw-mt-10" :chart-data="chartData"/>
    <p v-if="periodType == 'all'">*Referente aos últimos 24 meses</p>
  </div>
</template>
<script>
import StackedBarChart from "../charts/stacked-bar-chart";
import axios from "axios";
import loadingImage from 'images/spinner.svg';

export default {
  components: {
    StackedBarChart,
  },
  props: [
    "selectedMonth",
    "selectedYear",
    "periodType"
  ],
  watch: {
    selectedMonth(){
      this.fetch();
    },
    selectedYear(){
      this.fetch();
    },
    periodType(){
      this.fetch();
    },
  },
  data(){
    return {
      chartData: {
        labels: [],
        series: [[], []],
      },
      loading: false,
      error: false,
      loadingImage,
    }
  },
   mounted() {
    setTimeout(() => this.fetch(), 200)
  },
  methods: {
    fetch() {
      this.loading = true
      this.error = false

      const params = {
        month: this.selectedMonth,
        year: this.selectedYear,
        period_type: this.periodType,
      }

      axios
        .get(
          '/insights/appointments_absence', {params}
        )
        .then(response => {
          this.chartData = response.data.data
          this.chartData.series[0] = {
            name: "Consultas",
            color: "#51d88a",
            data: this.chartData.series[0],
          },
          this.chartData.series[1] = {
            name: "Cancelamentos",
            color: "#f66d9b",
            data: this.chartData.series[1],
          },
          this.loading = false
        }).catch(() => {
          this.loading = false
          this.error = true

        });
    },
  }
};
</script>
